import { IComponentController } from 'angular';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import { IStateParamsService } from 'angular-ui-router';
import { IFormulaireItemMenuItemClass } from '../../../../../core/services/formulaire/formulaire-item-menu-item.service';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';

interface IPageAl0004 extends IComponentController {
    monoOccurrence: IMonoOccurrence;        
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    dhdMultiOccurrenceOptions: IMultiOccurrenceOptions;
    formulaireCriteres: IFormulaire;
    valeursEcran: any;    
}

/* @ngInject */
export default function Al0004Controller(
    Formulaire: IFormulaireClass,
    al2008Route: IRoute,
    Menu: IMenuClass,    
    ecranDetails: IEcranDetailsResourcesEntite,
    MenuItemForage: IMenuItemForageClass,
    FormulaireItemMenuItem: IFormulaireItemMenuItemClass,
    FormulaireItem: IFormulaireItemClass,
    al2004Route: IRoute,
    al0003Route: IRoute,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass,
    $stateParams: IStateParamsService
) {
    const vm: IPageAl0004 = this;
    const [cw2] = [5, 15, 15, 15, 15];
    vm.valeursEcran = ecranDetails.valeurs;

    vm.menus = {
        prfdsc: [
            new MenuItemForage(
                'BTN_FORAGE_TE0004',
                al0003Route.NAME,
                () => ({ 
                    id: $stateParams.dlpcleint, 
                    dalcleint: $stateParams.dalcleint, 
                    tdlcleint: $stateParams.tdlcleint }))
        ]
    };

    vm.formulaireDLH = new Formulaire('LBL_HORAIRE',[
        new FormulaireItem('dlhdatvig', {
            largeur: 33, disabled: () => vm.valeursEcran.flghor === 3 ||vm.valeursEcran.flghor === 4
        }),
        new FormulaireItem('dlhpctrep', {
            largeur: 25,
            disabled: () => vm.valeursEcran.flghor === 3 ||vm.valeursEcran.flghor === 4
        }),
        new FormulaireItem('dlhtauhor', { readonly: () => !vm.valeursEcran.aldflgsal, 
            largeur: 25, disabled: () => vm.valeursEcran.flghor === 3||vm.valeursEcran.flghor === 4
        }),
        new FormulaireItemMenuItem(new MenuItemForage(
            'LBL_BTN_GEN',
            al2008Route.NAME,
            (data: any) => ({
                id: vm.monoOccurrence.data.$id,
                dlhcleint: vm.monoOccurrence.data.$id,
                dlpcleint: $stateParams.dlpcleint,
                dlhdatvig: data.dlhdatvig
            }),
            {
                iconButton: false,
                saveFirst: true,
                hidden: (data: any) => !data.dlhcleint || vm.valeursEcran.flghor === 4 || vm.valeursEcran.flghor === 3,
                icon: '',
                class: 'md-raised ex-button-action'
            }
        ), { largeur: cw2 }),
        new FormulaireItem('prfcleint', {
            largeur: 33,
            default: $stateParams.prfcleint
        }),
        new FormulaireItem('dlpcleint', {
            default: $stateParams.dlpcleint
        }),
        new FormulaireItem('dlhcom', {
            largeur: 33, disabled: () => vm.valeursEcran.flghor === 3||vm.valeursEcran.flghor === 4
        }),
        new FormulaireItem('dlhseqmod', {
            largeur: 25            
        }),        
        new FormulaireItem('dlhflgact', {
            largeur: 25,
            default: 1,
            disabled: () => vm.valeursEcran.flghor === 3
        })        
    ], {
        largeurDefaut: 100
    });
    // Detail Horaire du dossier d'absence
    vm.dhdMultiOccurrenceOptions = {
        bloc: 'dhd',
        fonctions: {
            edition:  vm.valeursEcran.flghor,
            nouveau: vm.valeursEcran.flghor,
            supprime: vm.valeursEcran.flghor
        },
        
        actionsNouveaux: new Menu([
            new MenuItemForage('',
                al2004Route.NAME,
                (rowData: any) => ({
                    id: vm.monoOccurrence.data.dhdcleint,
                    dlhcleint: vm.monoOccurrence.data.dlhcleint,
                    dalcleint: $stateParams.dalcleint
                }),
                {
                    icon: 'add_circle',
                    disabled: () => vm.valeursEcran.flghor === 2 || vm.valeursEcran.flghor === 3 || vm.valeursEcran.flghor === 4
                }
            )
        ]),
        colonnesCachees: [
            'dlhcleint'
        ],
        navigatePage: al2004Route.NAME,
        navigateParams: (data: any) => ({
            id: data.dhdcleint,
            dlhcleint: data.dlhcleint,
            dalcleint: $stateParams.dalcleint

        }),
        colonnesVisibles: [
            { nom: 'aftcod', largeur: 130 },
            { nom: 'aftdscfmt', largeur: 130 },
            { nom: 'vaesysjrssem', largeur: 130 },
            { nom: 'dhddursem', largeur: 130 },
            { nom: 'dhdqtetra', largeur: 130 },
            { nom: 'dhdqteabs', largeur: 130 },
            { nom: 'totqte', largeur: 130 },
            { nom: 'prctra', largeur: 130 }
        ]
    }

}
